import { render, staticRenderFns } from "./CloserSrc.vue?vue&type=template&id=187b3670&scoped=true&"
import script from "./CloserSrc.vue?vue&type=script&lang=js&"
export * from "./CloserSrc.vue?vue&type=script&lang=js&"
import style0 from "./CloserSrc.vue?vue&type=style&index=0&id=187b3670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b3670",
  null
  
)

export default component.exports